import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FtoTaskStep } from '../../enums';
import type { FtoReportStateService } from '../state-service';
import type { Event } from '@patsnap/tahiti-core';
import { FtoReportContext } from '../states/novelty-check-report-context';

@injectable()
export class FtoReportStateServiceImpl implements FtoReportStateService {
    constructor(
        @inject(FtoReportContext)
        private _context: FtoReportContext,
    ) { }

    getCurrentStep(): FtoTaskStep {
        return this._context.getCurrentStep();
    }

    async next(): Promise<void> {
        await this._context.next();
    }

    async previous(): Promise<void> {
        await this._context.previous();
    }

    async initialize(): Promise<void> {
        await this._context.initialize();
    }

    async goToStep(step: FtoTaskStep): Promise<void> {
        const targetState = this._context.getState(step);
        await this._context.transitionTo(targetState);
    }

    get onStateChange(): Event<FtoTaskStep> {
        return this._context.onStateChange;
    }
}
